/** Keep a console target on screen without pulling the marketing footer up. */

export type ConsoleScrollInput = {
  scrollY: number;
  elementTop: number;
  elementBottom: number;
  headerHeight: number;
  viewportHeight: number;
};

export function nextWindowScrollY(input: ConsoleScrollInput): number | null {
  const topLimit = input.headerHeight + 12;
  const bottomLimit = Math.max(topLimit + 1, input.viewportHeight - 12);
  const { elementTop, elementBottom, scrollY } = input;
  if (elementTop >= topLimit && elementBottom <= bottomLimit) {
    return null;
  }
  if (elementTop < topLimit) {
    return Math.max(0, scrollY + elementTop - topLimit);
  }
  const height = elementBottom - elementTop;
  if (height > bottomLimit - topLimit) {
    return Math.max(0, scrollY + elementTop - topLimit);
  }
  return Math.max(0, scrollY + elementBottom - bottomLimit);
}

export function scrollElementWithinConsole(element: HTMLElement): void {
  if (typeof window === 'undefined') {
    return;
  }
  const header = document.querySelector('.site-header');
  const headerHeight = header instanceof HTMLElement ? header.getBoundingClientRect().height : 0;
  const rect = element.getBoundingClientRect();
  const next = nextWindowScrollY({
    scrollY: window.scrollY,
    elementTop: rect.top,
    elementBottom: rect.bottom,
    headerHeight,
    viewportHeight: window.innerHeight,
  });
  if (next == null || Math.abs(next - window.scrollY) < 2) {
    return;
  }
  window.scrollTo(0, next);
}

export function releaseDocumentFocus(): void {
  const active = document.activeElement;
  if (active instanceof HTMLElement && active !== document.body) {
    active.blur();
  }
}
